module.exports = __webpack_public_path__ + "media/images/sidebar-arrow-selected-068c903dedf0ea439fd07c63416f5e40.svg";